
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import {
  HiOutlineScale,
  HiOutlineArrowUpRight,
} from "react-icons/hi2";

import { getAllServices } from "../redux/actions/services";
import { Loader } from "./utils";
import SmallBlogs from "./utils/SmallBlogs";

/* ============================================
   SIDEBAR - LEGAL SERVICES
============================================ */

function RelatedBlogs() {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  const { isLoading, Allservices } = useSelector(
    (state) => state.Services || {}
  );

  const isEnglish = (
    i18n.resolvedLanguage ||
    i18n.language ||
    "ar"
  )
    .toLowerCase()
    .startsWith("en");

  useEffect(() => {
    dispatch(getAllServices(1, 5));
  }, [dispatch]);

  const services = Array.isArray(Allservices)
    ? Allservices.slice(0, 5)
    : [];

  const content = {
    eyebrow: isEnglish
      ? "OUR PRACTICE AREAS"
      : "مجالات عملنا",

    title: isEnglish
      ? "Legal Services"
      : "خدمات قانونية",

    description: isEnglish
      ? "Explore the legal services provided by our office."
      : "تعرف على الخدمات القانونية التي تقدمها المؤسسة.",

    all: isEnglish
      ? "All Services"
      : "جميع الخدمات",

    empty: isEnglish
      ? "No services are available."
      : "لا توجد خدمات متاحة حاليًا.",
  };

  return (
    <div
      className="
        overflow-hidden
        rounded-[22px]

        border border-skin-border
        bg-skin-surface

        shadow-[0_10px_35px_rgba(15,39,55,0.045)]

        dark:shadow-none
      "
    >
      {/* ======================================
          SIDEBAR HEADER
      ====================================== */}

      <div
        className="
          border-b border-skin-border
          px-5 py-6
          sm:px-6
        "
      >
        <div className="mb-5 flex items-center justify-between">

          <span className="eyebrow text-skin-accent">
            {content.eyebrow}
          </span>

          <div
            className="
              flex h-11 w-11
              items-center justify-center
              rounded-xl
              bg-skin-soft
              text-skin-accent
            "
          >
            <HiOutlineScale
              size={23}
              aria-hidden="true"
            />
          </div>

        </div>

        <h2 className="h5 text-skin-heading">
          {content.title}
        </h2>

        <p className="body-3 mt-2 text-skin-muted">
          {content.description}
        </p>
      </div>

      {/* ======================================
          SERVICES LIST
      ====================================== */}

      <div
        className="
          max-h-[650px]
          overflow-y-auto
          p-3
          sm:p-4
        "
      >
        {isLoading ? (
          <div className="flex min-h-[180px] items-center justify-center">
            <Loader />
          </div>
        ) : services.length > 0 ? (
          <div className="flex flex-col gap-3">

            {services.map((service, index) => (
              <SmallBlogs
                key={service._id || service.id || index}
                blogs={service}
              />
            ))}

          </div>
        ) : (
          <p className="body-3 py-8 text-center text-skin-muted">
            {content.empty}
          </p>
        )}
      </div>

      {/* ======================================
          ALL SERVICES LINK
      ====================================== */}

      <div className="border-t border-skin-border p-4">

        <Link
          to="/AllServiceses"
          onClick={() => window.scrollTo(0, 0)}
          className="
            group flex min-h-[46px]
            items-center justify-between
            gap-3

            rounded-xl
            bg-skin-soft
            px-4 py-3

            text-skin-heading

            transition-all duration-300

            hover:bg-skin-raised

            focus-visible:outline-none
            focus-visible:ring-2
            focus-visible:ring-skin-accent
          "
        >
          <span className="button-sm">
            {content.all}
          </span>

          <HiOutlineArrowUpRight
            size={19}
            aria-hidden="true"
            className="directional-arrow text-skin-accent"
          />
        </Link>

      </div>
    </div>
  );
}

export default RelatedBlogs;
